import mqtt from 'mqtt';
enum ConnectionStatus {
  Connect = 'connect',
  Reconnect = 'reconnect',
  Error = 'error',
  Message = 'message',
}

interface ClientOptions {
  clientId?: string;
  username: string;
  password: string;
  subscribes?: string | string[];
  onConnect?: AnyFunc;
  onError?: AnyFunc;
  onReconnect?: AnyFunc;
  onMessage?: AnyFunc;
  will?: {
    /**
     * the topic to publish
     */
    topic: string;
    /**
     * the message to publish
     */
    payload: Buffer | string;
    /**
     * the QoS
     */
    qos: any;
    /**
     * the retain flag
     */
    retain: boolean;
    /*
     *  properies object of will
     * */
    properties?: {
      willDelayInterval?: number;
      payloadFormatIndicator?: boolean;
      messageExpiryInterval?: number;
      contentType?: string;
      responseTopic?: string;
      correlationData?: Buffer;
      userProperties?: any;
    };
  };
}

class CustormMqttClient {
  options: ClientOptions;
  url: string;
  client: any;
  constructor(url: string, options: ClientOptions) {
    this.url = url;
    this.options = options;
    this.initMqtt();
  }
  initMqtt() {
    const { clientId = '', username, password, will } = this.options;
    const connectOpt = {
      clean: true,
      connectTimeout: 4000,
      clientId,
      username,
      password,
      will,
      protocolVersion: 5,
      reconnectPeriod: 5000,
      keepalive: 5,
    };
    this.client = mqtt.connect(this.url, connectOpt);
    this.initEventListener();
  }

  initSubscribe() {
    const { subscribes } = this.options;
    this.client.subscribe(subscribes);
  }

  initEventListener() {
    const { onConnect, onError, onReconnect, onMessage } = this.options;
    this.client.on(ConnectionStatus.Connect, () => {
      onConnect && onConnect(this);
      this.initSubscribe();
    });
    this.client.on(ConnectionStatus.Reconnect, (error: any) => {
      console.log('reconnect');
      onReconnect && onReconnect(error);
    });

    this.client.on(ConnectionStatus.Error, (error: any) => {
      console.log('error');
      onError && onError(error);
    });

    this.client.on(ConnectionStatus.Message, (topic: string, message: any) => {
      onMessage && onMessage(topic, message.toString());
    });
    // this.client.on('disconnect', () => {
    //   console.log(
    //     'Disconnected from MQTT broker, waiting 5 seconds before reconnecting...'
    //   );
    //   setTimeout(() => {
    //     this.client.reconnect();
    //   }, 5000);
    // });
  }

  subscribe(topic: string | string[], opts: any, cb?: AnyFunc) {
    this.client.subscribe(topic, { qos: 1, nl: false, rap: false }, cb);
    return this;
  }

  unsubscribe(topic: string | string[]) {
    this.client.unsubscribe(topic);
    return this;
  }

  publish(topic: string, message: string | Buffer) {
    this.client.publish(topic, message);
  }
}

export default CustormMqttClient;
